<template>
  <el-dialog
    title="修改装箱数据"
    :visible.sync="visible"
    width="760px"
    custom-class="box-help-dialog"
  >
    <div class="edit-meta">{{ meta }}</div>
    <el-form label-width="88px">
      <el-form-item label="装箱数量">
        <el-input-number
          v-model="qty"
          :controls="false"
          :step-strictly="true"
          @keyup.enter.native="confirm"
        />
        <div class="dialog-error">{{ error }}</div>
      </el-form-item>
    </el-form>
    <BoxSpecFields v-model="spec" :errors="specErrors" compact />
    <span slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="confirm">确认修改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BoxSpecFields from "./BoxSpecFields.vue";
import { normalizeBoxSpec, validateBoxSpec } from "../spec";

export default {
  name: "EditRecordDialog",
  components: {
    BoxSpecFields,
  },
  data() {
    return {
      // 弹窗显示状态。
      visible: false,
      // 当前编辑的 SKU + 箱号聚合 key。
      key: "",
      // 用户输入的修改后装箱数量。
      qty: undefined,
      // 当前记录允许修改的最大数量。
      maxQty: 0,
      // 弹窗中展示的记录说明文案。
      meta: "",
      // 数量校验或业务校验错误文案。
      error: "",
      // 当前箱号的重量和箱规。
      spec: {
        weight: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
      },
      // 重量和箱规校验错误文案。
      specErrors: {
        weight: "",
        length: "",
        width: "",
        height: "",
        spec: "",
      },
    };
  },
  methods: {
    // 供父组件通过 $refs 调用，打开弹窗并写入编辑上下文。
    open: function (payload) {
      this.visible = true;
      this.key = payload.key;
      this.qty = payload.qty;
      this.maxQty = payload.maxQty;
      this.meta = payload.meta;
      this.spec = normalizeBoxSpec(payload.spec);
      this.specErrors = {
        weight: "",
        length: "",
        width: "",
        height: "",
        spec: "",
      };
      this.error = "";
    },
    // 关闭弹窗并重置内部状态。
    close: function () {
      this.visible = false;
      this.key = "";
      this.qty = undefined;
      this.maxQty = 0;
      this.meta = "";
      this.error = "";
      this.spec = {
        weight: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
      };
      this.specErrors = {
        weight: "",
        length: "",
        width: "",
        height: "",
        spec: "",
      };
    },
    // 校验修改数量和箱规，并把确认事件交给父组件处理真实数据变更。
    confirm: function () {
      // 标准化后的修改数量。
      const nextQty = Number(this.qty);
      if (this.qty === undefined || this.qty === null || this.qty === "") {
        this.error = "请输入修改后的数量";
        return;
      }
      if (!Number.isInteger(nextQty)) {
        this.error = "修改数量必须为整数";
        return;
      }
      if (nextQty <= 0) {
        this.error = "修改数量必须大于 0";
        return;
      }
      if (nextQty > this.maxQty) {
        this.error = `修改数量不能超过可用数量 ${this.maxQty}`;
        return;
      }

      const specValidation = validateBoxSpec(this.spec);
      this.specErrors = specValidation.errors;
      if (!specValidation.ok) {
        this.error = specValidation.message;
        return;
      }

      this.error = "";
      this.$emit("confirm", {
        key: this.key,
        qty: nextQty,
        spec: this.spec,
        done: this.close,
        fail: this.setError,
      });
    },
    // 供父组件在业务校验失败时回写错误文案。
    setError: function (message) {
      this.error = message;
    },
  },
};
</script>

<style scoped>
.edit-meta {
  margin-bottom: 18px;
  color: #8c939d;
  line-height: 1.5;
}

.dialog-error {
  min-height: 20px;
  margin-top: 6px;
  color: #ff0000;
  font-size: 12px;
  line-height: 20px;
}

::v-deep .box-help-dialog .el-input-number {
  width: 100%;
}
</style>
